module.exports = __webpack_public_path__ + "static/media/blur_placeholder.e3af8c0f.jpg";